import { atomWithStorage } from 'jotai/utils';

/**
 * Typesense Debug Atoms
 * These atoms store debug settings for the new Typesense listing system
 */

export type SortScoreVersion = 'v1' | 'v2' | 'v3' | 'v4' | 'v5';

// Store debug settings in localStorage to persist between sessions
export const typesenseDebugVisibleAtom = atomWithStorage<boolean>(
  'typesenseDebugVisible',
  false
);
typesenseDebugVisibleAtom.debugLabel = 'typesenseDebugVisibleAtom';

export const debugSortScoreVersionAtom = atomWithStorage<SortScoreVersion>(
  'debugSortScoreVersion',
  'v1'
);
debugSortScoreVersionAtom.debugLabel = 'debugSortScoreVersionAtom';

// Always fetch both free and premium tracks
export const debugFetchFreeAndPremiumAtom = atomWithStorage(
  'debugFetchFreeAndPremium',
  true
);
debugFetchFreeAndPremiumAtom.debugLabel = 'debugFetchFreeAndPremiumAtom';
